import React from "react";

export const exportExcel = (payload, name) => {
    import('xlsx').then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(payload);
        const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
        saveAsExcelFile(excelBuffer, name);
    });
}

const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then(module => {
        if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        }
    });
}


export const error = (field, rules, value = "") => {

    switch (rules) {
        case 'required':
            if (field === '') {

                return <><span className="text-red-600 font-bold text-xs">El campo es obligatorio</span> <br/></>;
            }
            break
        case 'maxLength':
            if (field === undefined) {

                return <><span
                    className="text-red-600 font-bold text-xs">{`El campo solo permite máximo ${value} caracteres`}</span>
                    <br/></>;
            }
            if (typeof field === 'number') {
                if (field.toString().length > parseInt(value)) {

                    return <><span
                        className="text-red-600 font-bold text-xs">{`El campo solo permite máximo ${value} caracteres`}</span><br/></>;
                }
            } else {
                if (field.length > parseInt(value)) {

                    return <><span
                        className="text-red-600 font-bold text-xs">{`El campo solo permite máximo ${value} caracteres`}</span><br/></>;
                }
            }

            break
        case 'pattern':

            if (parseInt(value) === 1) {
                // letras y numeros
                if (!/^[A-Za-z_]+$/i.test(field)) {

                    return <><span className="text-red-600 font-bold text-xs">Formato incorrecto</span><br/></>;
                }
            }
            if (parseInt(value) === 2) {
                // contraseña
                if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*{}-])(?=.{8,30})/i.test(field)) {

                    return <><span className="text-red-600 font-bold text-xs">Formato incorrecto (debe tener al menos una mayuscula, número y un caracter especial)</span><br/></>;
                }
            }

            break
        default:
            return '';

    }

}

export const convertirModena = (value) => {
    if (isNaN(value)) {
        return "0";
    }
    //es-CO
    //COP
    const convertFormat = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });
    return convertFormat.format(Math.round(value))
}

export const convertirModenaSinFormato = (value) => {
    if (isNaN(value)) {
        return "0";
    }
    //es-CO
    //COP
    const convertFormat = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0
    });
    return convertFormat.format(value)
}

export const formatCurrency = (value) => {

    return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
}


export const formatNumber = (value, decimals) => {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals)
}


export const formatFecha = (date) => {

    const d = new Date(date)

    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    let year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
}

export const arrayNum = (num) => {
    if (isNaN(num)) {
        return [];
    }
    const data = [];
    for (let i = 1; i <= num; i++) {
        data.push(i)
    }

    return data;
}

export function sumaIngreso(fields) {
    let suma = 0;
    for (const field of fields) {
        suma += field['sub_total'];
    }
    return suma;
}

export function sumaCompensacion(fields) {
    let comarra = [];
    for (const refElement of fields) {
        comarra = [...comarra, ...refElement['compensacion']]
    }
    const groups = new Set(comarra.map(item => item.descrip_abrev));

    let obje = {};
    groups.forEach(g => {
        obje[g] = [];
        for (const el of comarra) {
            if (g === el.descrip_abrev) {
                obje[g] = [...obje[g], el]
            }
        }
    })
    let objeSuma = {};
    for (const refKey in obje) {
        objeSuma[refKey] = 0;

        for (const refElement of obje[refKey]) {
            if (refElement.descrip_abrev === refKey) {
                objeSuma[refKey] += refElement['valor_porcentaje']
            }
        }

    }
    return Object.keys(objeSuma).map(function (key) {
        return [key, objeSuma[key]];
    });
}

export function sumaPrestacion(fields) {
    let comarra = [];
    for (const refElement of fields) {
        comarra = [...comarra, ...refElement['prestacion']]
    }
    const groups = new Set(comarra.map(item => item.descrip_abrev.trim().toUpperCase()));

    let obje = {};
    groups.forEach(g => {
        obje[g] = [];
        for (const el of comarra) {
            if (g === el.descrip_abrev.trim().toUpperCase()) {
                obje[g] = [...obje[g], el]
            }
        }
    })
    let objeSuma = {};
    for (const refKey in obje) {
        objeSuma[refKey] = 0;

        for (const refElement of obje[refKey]) {
            if (refElement.descrip_abrev.trim().toUpperCase() === refKey) {
                objeSuma[refKey] += refElement['valor_porcentaje']
            }
        }

    }
    return Object.keys(objeSuma).map(function (key) {
        return [key, objeSuma[key]];
    });
}
